import React from 'react';
import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { ReactComponent as SlackIcon } from 'assets/slack.svg';
import { combinedFeatureFlagsSelector } from '@mm/state/selectors/featureFlagsSelectors';
import {
  ButtonColor,
  PrimaryButton,
} from '../../../../../../../../common/buttons/PrimaryButton/PrimaryButton';
import { PrimaryToolTip } from '../../../../../../../../common/components/PrimaryToolTip/PrimaryToolTip';
import { ReactComponent as AccountIcon } from '../../../../../../../../layout/BotBuilderSidebar/UserDropdown/UserDropdownIcons/UserFallback.svg';
import { useConnectSlack } from './use-connect-slack';

type Props = {
  isAccountConnected: boolean;
  accountsCount?: number;
  showUpgradeModal: (onSuccessBilling: () => void) => void;
  className?: string;
};

export const SlackHeaderComponent = (props: Props) => {
  const { isAccountConnected, accountsCount, showUpgradeModal, className } =
    props;

  const { connectSlack } = useConnectSlack();
  const hasNativeIntegrationsFeature = useSelector(
    combinedFeatureFlagsSelector,
  ).nativeIntegrations;

  const onConnectAccountClick = e => {
    if (!hasNativeIntegrationsFeature) {
      e.stopPropagation();
      showUpgradeModal(connectSlack);
    } else {
      connectSlack();
    }
  };

  const headerClassname = classnames(
    'integrations__header',
    'integrations__header--hidden-section',
    className,
    {
      'integrations__header--account-connected': isAccountConnected,
    },
  );

  return (
    <div className={headerClassname}>
      <div className="integrations__header-main">
        <div className="integrations__header-icon integrations__slack-header-icon">
          <SlackIcon />
        </div>
        <div>
          <div className="integrations__header-title"> Slack Integration</div>
          <div className="integrations__header-info">
            <div className="integrations__header-learn-more">
              Get notified about customers' activity via Slack
            </div>
          </div>
        </div>
      </div>
      {!isAccountConnected && (
        <PrimaryButton
          className="integrations__header-add-button"
          onClick={onConnectAccountClick}
          color={ButtonColor.blue}
        >
          Add an Account
        </PrimaryButton>
      )}
      {isAccountConnected && (
        <div className="integrations__header-actions">
          <PrimaryToolTip
            align="center"
            position="bottom"
            anchorElement={
              <div className="integrations__header-status">
                Slack Accounts
                <AccountIcon className="integrations__header-status-icon" />
                <div className="integrations__header-status-count">
                  {accountsCount}
                </div>
              </div>
            }
            useHover
          >
            Slack Accounts used in сonnections
          </PrimaryToolTip>
          <PrimaryButton
            className="integrations__header-add-button-secondary"
            onClick={onConnectAccountClick}
            color={ButtonColor.secondaryBlue}
          >
            Add an Account
          </PrimaryButton>
        </div>
      )}
    </div>
  );
};
